import type { MiddlewareAPI } from '@reduxjs/toolkit'

import { type Middleware, type Action, BulkOfActions } from './actions'

export const bulkDispatchMiddleware: Middleware = (store) => {
    function dispatchChildActions(store: MiddlewareAPI, action: Action) {
        if (BulkOfActions.match(action)) {
            action.payload.forEach(function (childAction) {
                dispatchChildActions(store, childAction)
            })
        } else {
            store.dispatch(action)
        }
    }

    return (next) => (action) => {
        if (BulkOfActions.match(action)) {
            dispatchChildActions(store, action)
        }
        return next(action)
    }
}
